// Partnerships

export const campaignTypes = {
    MONEY: "money",
    PRODUCT: "product",
    EXPERIENCE: "experience",
    MONEY_PRODUCT: "money_product",
    MONEY_EXPERIENCE: "money_experience",
  };
  